import type { Transition } from "@uirouter/core";

import { EPresetOption } from "app/constants/websiteKeywordsPresetOptions";

const WORLD_WIDE = "999";
const noSupportForWorldWide = [EPresetOption.Cannibalization, EPresetOption.HighTraffic];

export const onRedirectAlignPresets = (transition: Transition) => {
    const fromState = transition.from().name;
    const fromParams = transition.params("from");
    const toParams = transition.params();
    const toState = transition.to().name;

    if (toParams.country === WORLD_WIDE && noSupportForWorldWide.includes(toParams.trafficPreset as EPresetOption)) {
        return { params: { ...toParams, trafficPreset: undefined } };
    }

    if (toState === fromState) {
        // when moving from single to compare and vice versa, we need to reset the preset param
        if (toParams.key?.length !== fromParams.key?.length && toParams.trafficPreset) {
            return { params: { ...toParams, trafficPreset: undefined } };
        }
    }
};
